import { createMhBackendProjectAdapter, parseProjectExtraInfo } from '@/2D3DEditer/adapters/mhBackendProjectAdapter'
import { loadFloorplanInputDraft } from '@/ikkodate/utils/floorplanInputDraft'

export function buildArchitecturePlanQuery(query = {}) {
  const next = {}
  if (query.lang) next.lang = query.lang
  if (query.idempotencyKey) next.idempotencyKey = query.idempotencyKey
  return next
}

const COMPLETED_PROJECT_STATUSES = {
  RUNNING: true,
  SUCCESS: true,
  FAILED: true
}

export function isCloudWizardCompleted(project) {
  if (!project || typeof project !== 'object') return false
  const extra = parseProjectExtraInfo(project.extraInfo)
  if (extra && extra.editorJsonPath) return true
  if (extra && extra.is_design === true) return true
  if (Array.isArray(project.successDesigns) && project.successDesigns.length > 0) return true
  const status = String(project.status || '').toUpperCase()
  return COMPLETED_PROJECT_STATUSES[status] === true
}

async function defaultGetProject(idempotencyKey) {
  return createMhBackendProjectAdapter().getProject(idempotencyKey)
}

export async function hasCompletedWizardProject(idempotencyKey, options = {}) {
  if (!idempotencyKey) return false
  const getProject = typeof options.getProject === 'function'
    ? options.getProject
    : defaultGetProject
  try {
    const result = await getProject(idempotencyKey)
    const project = result && result.ok ? result.data : null
    return isCloudWizardCompleted(project)
  } catch (_error) {
    return false
  }
}

const DEFAULT_ROUTES = {
  projects: 'projects-ikkodate',
  constraints: 'ikkodate_architecture_plan_constraints',
  editor: 'ikkodate_architecture_plan_editor'
}

function ensureIdempotencyKey(to, next, fallbackRoute = DEFAULT_ROUTES.projects) {
  if (!to.query || !to.query.idempotencyKey) {
    next({ name: fallbackRoute })
    return false
  }
  return true
}

export async function enterArchitecturePlanConstraints(to, from, next, options = {}) {
  const query = buildArchitecturePlanQuery(to.query)
  const routes = { ...DEFAULT_ROUTES, ...(options.routes || {}) }

  if (!ensureIdempotencyKey(to, next, routes.projects)) return

  if (await hasCompletedWizardProject(to.query.idempotencyKey, options)) {
    next({
      name: routes.editor,
      query
    })
    return
  }

  next()
}

export async function enterArchitecturePlanEditor(to, from, next, options = {}) {
  const query = buildArchitecturePlanQuery(to.query)
  const routes = { ...DEFAULT_ROUTES, ...(options.routes || {}) }

  if (!ensureIdempotencyKey(to, next, routes.projects)) return

  if (await hasCompletedWizardProject(to.query.idempotencyKey, options)) {
    next()
    return
  }

  next({
    name: routes.constraints,
    query
  })
}

export function enterArchitecturePlanProduct(to, from, next, options = {}) {
  const query = buildArchitecturePlanQuery(to.query)
  const routes = { ...DEFAULT_ROUTES, ...(options.routes || {}) }

  if (!ensureIdempotencyKey(to, next, routes.projects)) return

  if (!loadFloorplanInputDraft(to.query.idempotencyKey)) {
    next({
      name: routes.constraints,
      query
    })
    return
  }

  next()
}
